<style>
    /*.form-container{*/
    /*width:500px;*/
    /*}*/
</style>

<template>
    <Modal
            v-model="showModal"
            :title="title"
            :loading="true"
            :styles="{top: '20px',width:'600px'}"
    >
        <div slot="footer">
            <Button type="text" size="large" @click="modalCancel">取消</Button>
            <Button type="primary" size="large" @click="handleSubmit('userForm')" :loading="saving">确定</Button>
        </div>
        <Form :model="formItem" :rules="ruleValidate" :label-width="100" ref="userForm"
              @keyup.enter.native="handleSubmit('userForm')">
            <FormItem label="账号" prop="account">
                <Input v-model="formItem.account" placeholder="" :disabled="disabled"></Input>
            </FormItem>
            <FormItem label="密码" prop="password">
                <Input v-model="formItem.password" type="password" :placeholder="passwordhint"></Input>
            </FormItem>
            <FormItem label="姓名" prop="name">
                <Input v-model="formItem.name" placeholder=""></Input>
            </FormItem>
            <FormItem label="电话" prop="mobile">
                <Input v-model="formItem.mobile" placeholder=""></Input>
            </FormItem>
            <FormItem label="状态" prop="state">
                <Select v-model="formItem.state">
                    <Option :value="1" label="正常"></Option>
                    <Option :value="0" label="禁用"></Option>
                </Select>
            </FormItem>
            <FormItem label="是否管理员" prop="isadmin">
                <Select v-model="formItem.isadmin">
                    <Option :value="1" label="管理员"></Option>
                    <Option :value="0" label="普通"></Option>
                </Select>
            </FormItem>
            <FormItem label="角色" prop="roleId">
                <CheckboxGroup v-model="formItem.roleIds">
                    <Checkbox v-for="role in roleList" :label="role.id" :key="role.id">{{role.name}}</Checkbox>
                </CheckboxGroup>
            </FormItem>
            <FormItem label="校区" prop="zoneId">
                <CheckboxGroup v-model="formItem.zoneIds">
                    <Checkbox v-for="zone in zoneList" :label="zone.id" :key="zone.id">{{zone.name}}</Checkbox>
                </CheckboxGroup>
                <!--<Select v-model="formItem.zoneId">-->
                <!--<Option value="" ></Option>-->
                <!--<Option v-for="zone in zoneList" :value="zone.id" :key="zone.id">{{ zone.name }}</Option>-->
                <!--</Select>-->
            </FormItem>
        </Form>
    </Modal>
</template>
<script>
  export default {
    name: 'UserForm',
    data() {
      return {
        title: '',
        showModal: false,
        pageName: this.$route.name,
        saving: false,
        editMode: null,
        zoneList: [],
        roleList: [],
        formItem: {
          id: '',
          name: '',
          account: '',
          password: '',
          mobile: '',
          state: 1,
          isadmin: 0,
          // zoneId:null,
          roleIds: [],
          zoneIds: []
        },
        ruleValidate: {
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          account: [
            {required: true, message: '请输入账号名', trigger: 'blur'}
          ],
          state: [
            {type: 'integer', trigger: 'blur'}
          ]
        }
      }
    },
    mounted() {
      this.loadZoneList();
      this.loadRoleList();
    },
    activated() {

    },
    methods: {
      loadZoneList() {
        this.$api.user.getZoneList().then(resp => {
          if (resp.state == 'ok') {
            this.zoneList = resp.data;
          } else {
            this.$Message.error('获取校区列表异常：' + resp.msg);
          }
        });
      },
      loadRoleList() {
        this.$api.role.getAll().then(resp => {
          if (resp.state == 'ok') {
            this.roleList = resp.data;
          } else {
            this.$Message.error('获取角色列表异常：' + resp.msg);
          }
        });
      },
      packagingFormData() {
        let postFormData = {};
        for (var i in this.formItem) {
          if (this.formItem.hasOwnProperty(i)) {
            if (i == 'zoneIds') {
              if (this.formItem[i] && this.formItem[i].length > 0) {
                postFormData['zoneIds'] = this.formItem[i].join(',');
              }
            } else if (i == 'roleIds') {
              if (this.formItem[i] && this.formItem[i].length > 0) {
                postFormData['roleIds'] = this.formItem[i].join(',');
              }
            } else {
              postFormData['user.' + i] = this.formItem[i];
            }

          }
        }
        return postFormData;
      },
      handleReset(name) {
        this.$refs[name].resetFields();
      },
      modalCancel() {
        this.showModal = false;
        this.$refs['userForm'].resetFields();
      },
      handleSubmit(name) {
        let self = this;
        this.$refs[name].validate((valid) => {
          try {
            if (valid) {
              self.saving = true;
              self.$api.user.save(self.packagingFormData()).then(resp => {
                if (resp.state == 'ok') {
                  this.$Message.info({
                    content: '保存成功',
                    onClose() {
                      self.showModal = false;
                    }
                  });
                  self.saving = false;
                  self.$emit('close');
                } else {
                  self.saving = false;
                  self.$Message.error(resp.msg);
                }
              });
            } else {
              self.$Message.error('表单校验不通过');
            }
          } catch (err) {
            console.log(err);
          }

        })
      },
      handleFormatError(file) {
        this.$Message.error('格式不正确');
      },
      loadInfo(id, callback) {
        let self = this;
        this.$api.user.getOne({id: id}).then(resp => {
          if (resp.state == 'ok') {
            self.formItem.id = resp.data.user.id;
            self.formItem.name = resp.data.user.name;
            self.formItem.account = resp.data.user.account
            self.formItem.state = resp.data.user.state;
            self.formItem.mobile = resp.data.user.mobile;
            // self.formItem.zoneId = resp.data.zoneId;
            self.formItem.isadmin = resp.data.user.isadmin;
            self.formItem.roleIds = resp.data.roleIds || [];
            self.formItem.zoneIds = resp.data.zoneIds || [];
            callback && callback();
          } else {
            self.$Message.error(resp.msg);
          }
        });
      },
      showWin(userId) {
        let self = this;

        self.formItem.id = null;
        self.formItem.name = null;
        self.formItem.account = null;
        self.formItem.state = null;
        self.formItem.mobile = null;
        // self.formItem.zoneId = null;
        self.formItem.isadmin = null;
        self.formItem.roleIds = [];
        self.formItem.zoneIds = [];

        self.$refs['userForm'].resetFields();
        self.saving = false;
        if (userId) {
          self.title = '修改';
          self.editMode = 'edit';
          self.loadInfo(userId, function () {
            self.showModal = true;
          });
        } else {
          self.formItem.id = "";
          self.title = '新增';
          self.editMode = 'add';
          self.showModal = true;
        }
      }
    },
    computed: {
      disabled: function () {
        if (this.editMode == 'edit') {
          return true;
        } else {
          return false;
        }
      },
      passwordhint: function () {
        if (this.editMode == 'edit') {
          return '****************';
        } else {
          return '不填则默认密码123456';
        }
      }
    }
  }
</script>
